import React from 'react';
import { NavLink } from 'react-router-dom';
import SarasTrans from '../../../../library/notifications/SarasTrans';

const DashSCRow = (props) => {
    const { viewData } = props;


    return (
        <li className="uiInlineFlex uiLinkButton">
            <NavLink target="_blank" to={viewData.dataList.href}>
                <span><SarasTrans value={viewData.valF} /></span>
            </NavLink>
        </li>
    )
}

export default DashSCRow;

